import React from 'react'
import { SocialIcon } from 'react-social-icons'


export default function Socials() {
  return (
    <div>
      <ul className="social-icons">
        <li><SocialIcon url="https://www.youtube.com/channel/UCU_dRalUFg-lEK_gapLJVuw" fgColor='#FCFF00' bgColor='transparent'/></li>
        <li><SocialIcon url="https://www.twitch.tv/d1sabl3dswe" fgColor='#FCFF00' bgColor='transparent'/></li>
         <li><SocialIcon url="https://www.tiktok.com/@d1sabl3dswe" fgColor='#FCFF00' bgColor='transparent'/></li>
         <li><SocialIcon url="https://www.instagram.com/d1sabl3dswe" fgColor='#FCFF00' bgColor='transparent'/></li>
         <li><SocialIcon url="https://x.com/d1sabl3d" aria-label="d1sabl3d on X" fgColor='#FCFF00' bgColor='transparent'/></li>
         <li><SocialIcon url="https://discord.gg/C8XSjvV6Vt" fgColor='#FCFF00' bgColor='transparent'/></li>
         
      </ul>
    </div>
  )
}
